import { Link } from 'react-router-dom'
import { EphiCounter } from '@/components/ephi-counter'
import { ServerNotifications } from '@/features/notifications/components/server-notifications'
import { RollStacks } from '@/components/roll-stacks'

export function Header() {
  return (
    <>
      {/* Notch Area */}
      <div className="fixed top-0 left-0 right-0 h-safe bg-background/80 backdrop-blur-sm z-50" />
      
      {/* Header */}
      <header className="fixed top-safe left-0 right-0 z-50 h-16 border-b bg-background/80 backdrop-blur-sm">
        <div className="mx-auto h-full w-full max-w-screen-xl px-4">
          <div className="flex h-full items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <img 
                src="https://fqgglbhawczmdkkhhtnz.supabase.co/storage/v1/object/public/public_assets/ui/logos/side_logo.png" 
                alt="Ephemeral Cards" 
                className="h-8 dark:filter dark:brightness-0 dark:invert"
              />
              <div className="bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-md uppercase">Beta</div>
            </Link>
            
            <div className="flex-1 flex justify-center translate-x-10">
              <RollStacks />
            </div>

            <div className="flex items-center gap-2">
              <ServerNotifications />
              <EphiCounter />
            </div>
          </div>
        </div>
      </header>
    </>
  )
} 